<mat-toolbar id="footer-background" class="px-24">
  <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
    <p *ngIf="!hideFooterMessage">
      <span>{{ footerMessage ? footerMessage : "" }}</span>
    </p>

    <button
      *ngIf="showFirstButton"
      mat-flat-button
      (click)="firstButtonEvent.emit()"
      color="primary"
      [disabled]="firstButtonDisable"
      [attr.eid]="'resetBtn'"
    >
      {{ firstButtonText }}
    </button>

    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
      <mat-spinner
        [diameter]="25"
        *ngIf="loadingIndicator"
        color="accent"
      ></mat-spinner>

      <button
        *ngIf="!hideBackButton"
        mat-stroked-button
        (click)="movePrevious.emit()"
        color="primary"
        [attr.eid]="componentName + 'BackBtn'"
      >
        Back
      </button>

      <button
        mat-flat-button
        [color]="nextButtonColor"
        type="button"
        (click)="moveNext.emit()"
        [disabled]="nextButtonDisable || loadingIndicator"
        [attr.eid]="componentName + 'NextBtn'"
      >
        {{ nextButtonText }}
      </button>
    </div>
  </div>
</mat-toolbar>
